import { Card, Col, Placeholder, Row, Spinner } from "react-bootstrap";

const EditProfielSkeleton = () => {
  return (
    <Card className="p-4 shadow-sm w-50">
      <Row className="justify-content-center mb-4">
        <Col md={4} className="text-center">
          <Placeholder as="div" animation="glow">
            <Placeholder
              className="rounded-circle"
              style={{ width: 120, height: 120 }}
            />
          </Placeholder>
          <Placeholder as="h5" animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="p" animation="glow">
            <Placeholder xs={4} />
          </Placeholder>
        </Col>
      </Row>

      <Placeholder as="div" animation="glow">
        <Placeholder xs={12} className="mb-2" />
        <Placeholder xs={12} className="mb-2" />
      </Placeholder>

      <Placeholder as="div" animation="glow" className="mt-3">
        <Placeholder xs={12} className="mb-2" />
        <Placeholder xs={12} className="mb-2" />
      </Placeholder>

      {/* <div className="text-center mt-3">
        <Spinner animation="border" />
      </div> */}
    </Card>
  );
};

export default EditProfielSkeleton;
